import React from 'react';
import {
  shape,
  string,
  arrayOf,
  number
} from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import {
  Card,
  CardMedia,
  Typography
} from '@one-thd/sui-atomic-components';
import { useSpecialBuy } from '../../context/SpecialBuyProvider';

const MobileCategoryTab = ({ category, entryId, index }) => {
  const { specialBuyEndpoint } = useSpecialBuy();
  const { categoryId, name, image, itemIds } = category;

  const { ref, clickID } = useImpression({
    data: {
      id: entryId,
      name: 'SpecialBuyBanner',
      component: 'SpecialBuyBanner',
      position: index,
      type: 'product',
      category: categoryId
    },
  });

  return (
    <Card
      href={`${specialBuyEndpoint}#${categoryId}`}
      CardActionAreaProps={{ target: '_blank' }}
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
      className="sui-paper sui-paper-outlined sui-rounded-base sui-flex sui-rounded-md
       sui-border-none sui-group/card-group"
      CardContentProps={{ disablePadding: true }}
    >
      <CardMedia
        className="sui-w-124px sui-max-w-100 sui-min-h-85px"
        src={image.url}
        aspect="square"
        alt={`${name} product image`}
        loading="lazy"
      />
      <Typography align="center">
        {name}
        <div>
          ({itemIds.length})
        </div>
      </Typography>
    </Card>
  );
};

MobileCategoryTab.propTypes = {
  category: shape({
    name: string.isRequired,
    itemIds: arrayOf(string.isRequired).isRequired,
    categoryId: string.isRequired,
    image: shape({
      url: string.isRequired
    }).isRequired
  }).isRequired,
  entryId: string,
  index: number.isRequired,
};

MobileCategoryTab.defaultProps = {
  entryId: '',
};

export { MobileCategoryTab };
